import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { squareApi } from "./squareApi";

export const getSquareConnectionStatus = createAsyncThunk(
  "squareConnect/getStatus",
  async (providerId) => {
    try {
      return await squareApi.getStatus({ provider_id: providerId });
    } catch (error) {
      // Status is passive chrome on page load — fail silently, manual entry still works.
      return null;
    }
  }
);

export const completeSquareConnection = createAsyncThunk(
  "squareConnect/connect",
  async ({ providerId, code }) => {
    try {
      const data = await squareApi.connect({ provider_id: providerId, code });
      toast.success("Square account connected");
      return data;
    } catch (error) {
      toast.error(error?.message || "Failed to connect Square account");
      return null;
    }
  }
);

export const disconnectSquare = createAsyncThunk(
  "squareConnect/disconnect",
  async (providerId) => {
    try {
      await squareApi.disconnect({ provider_id: providerId });
      toast.success("Square account disconnected");
      return true;
    } catch (error) {
      toast.error(error?.message || "Failed to disconnect Square account");
      return null;
    }
  }
);

export const squareConnectSlice = createSlice({
  name: "squareConnectStore",
  initialState: {
    status: null, // { connected, authorize_url, connection } per spec §6
    loading: { status: false, connect: false, disconnect: false },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSquareConnectionStatus.pending, (state) => {
        state.loading.status = true;
      })
      .addCase(getSquareConnectionStatus.fulfilled, (state, action) => {
        state.loading.status = false;
        if (action.payload) state.status = action.payload;
      })
      .addCase(completeSquareConnection.pending, (state) => {
        state.loading.connect = true;
      })
      .addCase(completeSquareConnection.fulfilled, (state, action) => {
        state.loading.connect = false;
        if (action.payload?.connection) {
          state.status = {
            ...(state.status || {}),
            connected: true,
            connection: action.payload.connection,
          };
        }
      })
      .addCase(disconnectSquare.pending, (state) => {
        state.loading.disconnect = true;
      })
      .addCase(disconnectSquare.fulfilled, (state, action) => {
        state.loading.disconnect = false;
        if (action.payload) {
          state.status = { ...(state.status || {}), connected: false, connection: null };
        }
      });
  },
});

export default squareConnectSlice.reducer;
